import { jsx as _jsx } from "react/jsx-runtime";
import { Image } from '@dixa/lib-shared-habla';
export const InstagramStoryImage = ({ attachment: { url, pretty_name }, onError, }) => {
    return _jsx(Image, { src: url, alt: pretty_name, onError: onError });
};
